import React from 'react';
import axios from 'axios';
import { DetailsHeader } from '../../Components/Details/Header/details-header.component';
import { Breadcrumbs } from '../../Components/Details/Breadcrumbs/breadcrumbs.component';
import { Description } from '../../Components/Details/Description/description.component';
import { Image } from '../../Components/Details/Image/details-image.component';
import Video from '../../Components/Details/Video/details-video.component';
import { Button } from '../../Components/Details/Button/details-button.component';
import RelatedPosts from '../../Components/Details/Related Posts/related-posts.component';
import { withRouter } from 'react-router-dom';
import { HowTo } from '../../Components/Details/How To/how-to.component';

class DetailPage extends React.Component {
    constructor(){
        super();

        this.state = {
            data: []
        }
    }

    componentDidMount(){
        axios.get(`https://crowdriff.com/wp-json/wp/v2/showcase?slug=${this.props.match.params.pageId}`)
            .then(res => this.setState({
                data: res.data
            }))
            .catch(err => console.log(err))
    }

    render() {
        const data = this.state.data;
        
        return (
            <div>
                {
                data.map((post, i) => {
                    return (
                        <div className="detail-page" key={i}>
                            <DetailsHeader />
                            <Breadcrumbs
                                title={post.title.rendered}
                            />
                            <Description 
                                logo={post.acf.case_study.logo}
                                title={post.title.rendered}
                                content={post.acf.case_study.description}
                            />
                            {
                                post.acf.case_study.asset_type === 'image' ? 
                                (
                                    <Image 
                                        image={post.acf.case_study.image}
                                        title={post.title.rendered}
                                    />
                                ) :
                                (
                                    <Video 
                                        id={post.acf.case_study.wistia_id}
                                        title={post.title.rendered}
                                    />
                                )
                            }
                            {
                                post.acf.case_study.button_url &&
                                <Button 
                                    text={post.acf.case_study.button_text}
                                    url={post.acf.case_study.button_url}
                                />
                            }
                            {
                                post.acf.case_study.how_to_do_it &&
                                <HowTo 
                                    content={post.acf.case_study.how_to_do_it}
                                />
                            }
                            <RelatedPosts 
                                thisSlug={this.props.match.params.pageId}
                            />
                        </div>
                    )
                })
                }
            </div>
        )
    }
}

export default withRouter(DetailPage)